export default (theme) => ({
  root: {},
  legend: { display: 'flex', justifyContent: 'flex-end' },
});
